import { type TCheckoutFlow } from '../types/checkoutTypes'

const CHECKOUT_FLOWS: TCheckoutFlow[] = ['download', 'old-users']

const isCheckoutFlow = (value: string): value is TCheckoutFlow =>
    CHECKOUT_FLOWS.includes(value as TCheckoutFlow)

/**
 * The flow survives a redirecting payment method as a url param, so it comes back as free text from
 * a page the visitor can edit. An unknown value means no flow at all, never a crash.
 */
export const parseCheckoutFlow = (value: string | undefined): TCheckoutFlow | undefined =>
    value && isCheckoutFlow(value) ? value : undefined
